export default "__VITE_ASSET__DcAfYWOp__"